// TODO(WEB): Implement react-native-splash-screen shim / maybe leave blank shim.

export const hide = () => {}

export default {
  hide,
}
